import { eventBus } from '../../foundation/eventBus';
import { collapsibleEvents } from '../search/collapsible';

export const journeyHeroBanner = () => {
    const overlapClass = "overlap";
    const panelRatioThreshold = 0.9;
    
    const isDropdownSelector = (element) => element.parentElement.className.split(' ').indexOf('range-selector')==-1;
    const calculateDropdownExpanse = (element) => element.parentElement.querySelector('.dropdown__content').offsetLeft + 
            element.parentElement.querySelector('.dropdown__content').clientWidth;
    const dropdownOverlaps = (element) => isDropdownSelector(element) && ((calculateDropdownExpanse(element) / window.innerWidth) > panelRatioThreshold);
    const init = component => {
        eventBus.subscribe(collapsibleEvents.trigger, (element) => {
            if (dropdownOverlaps(element)) {
                component.classList.add(overlapClass);
            }
        });
        eventBus.subscribe(collapsibleEvents.disarm, () => {
            component.classList.remove(overlapClass);
        });
    };
    return {
        init: init,
        selector: "[data-component='journey-hero-module']"
    };
};